import English from './en_US'
import Italian from './it_IT'
import Spanish from './es_AR'

export default {
  'en_US': English,
  'it_IT': Italian,
  'es_AR': Spanish
}
